/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/router/routes';
import middleware from './middleware';
import {LooseObject} from '@/types';
import {debug} from '@/utils/helpers';
import NProgress from 'nprogress';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const routeMiddleware: LooseObject = middleware.routeMiddleware;

const hasMiddleware = (name: string) =>
  Object.keys(routeMiddleware).includes(name);

function runMiddleware(middleware: string[], ...params: any) {
  middleware.forEach(async guard => {
    debug('[middleware] starting:', guard);
    if (hasMiddleware(guard)) {
      debug('[middleware] running:', guard);
      await routeMiddleware[guard](...params);
      debug('[middleware] exiting:', guard);
    }
  });
}

// Register beforeEach middleware
router.beforeEach((to, from, next) => {
  NProgress.start();
  // eslint-disable-next-line no-use-before-define
  /* eslint-disable */
  if (to?.meta?.middleware) {
    runMiddleware(to?.meta?.middleware, to, from, next);
  } else {
    next();
  }
});

// Register afterEach middleware
router.afterEach((to, from) => {
  NProgress.done();
  /* eslint-disable */
  if (middleware.afterEach.length > 0) {
    runMiddleware(middleware.afterEach, to, from);
  }
});

export default router;
